<div class="landing-background" [ngClass]="isDarkTheme ? 'dark' : 'light'">
  <div class="logo-container">
    <img [src]="imageSource" class="logo-class" />
  </div>
  <div class="background-image" [ngClass]="isDarkTheme ? 'background-image-dark' : 'background-image-light'">
    <div class="landing-container">
      <div class="mat-elevation-z8 landing-card">
        <mat-toolbar id="landing-toolbar">
          <span> {{ 'landingPage.welcomeTitle' | transloco }} </span>
        </mat-toolbar>
        <mat-card>
          <mat-card-header>
            <mat-card-title [ngClass]="isDarkTheme ? 'text-dark-theme' : 'text-light-theme'">
              <strong> {{ 'landingPage.subtitle' | transloco }} </strong>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <span *ngIf="!isContractSigned">
                <div>
                  <p *ngFor="let bulletEntry of bulletList ; index as i">
                    {{i+1}}.&emsp;{{bulletEntry}}
                  </p>
                </div>
              <div *ngFor="let contract of contracts">
                <div class="collapsible contractBox" (click)="contract.isExpanded=!contract.isExpanded">{{'landingPage.serviceAggreement' | transloco}}
                  <mat-icon *ngIf="!contract.isExpanded">keyboard_arrow_right</mat-icon>
                  <mat-icon *ngIf="contract.isExpanded">keyboard_arrow_down</mat-icon>
                </div>
                <object [hidden]="!contract.isExpanded" class="inPagePdf" [data]="contract.pdfUrl"
                  type="application/pdf">
                </object>
              </div>
            </span>
            <span *ngIf="!isUserActivated">
              <p>
                {{ 'landingPage.maxUser' | transloco }}
              </p>
              <p>
                {{ 'landingPage.contactSales' | transloco }}
                <a href=mailto:upgrade@packaging-cockpit.com>upgrade&#64;packaging-cockpit.com</a>
              </p>
            </span>
            <blockquote *ngIf="!isContractSigned">
              <div>
                {{ 'landingPage.signContract' | transloco}}
                <mat-checkbox labelPosition="before" [checked]="contractSignedCheck" (change)="contractSignedCheck=!contractSignedCheck"></mat-checkbox>
              </div>
              <p>
                <button type="button" class="floatRight" mat-raised-button color="primary" (click)="signContract()" [disabled]="!contractSignedCheck">{{ 'landingPage.accept' | transloco }}</button>
              </p>
            </blockquote>
            <p >
              {{ 'landingPage.welcomeEndText' | transloco }}
            </p>
            <strong >
              {{ 'landingPage.yourPacoTeam' | transloco }}
            </strong>
          </mat-card-content>
          <mat-card-actions class="flex-row-space-around"> </mat-card-actions>
        </mat-card>
      </div>
      <div class="footer-text">
        <span class="mat-headline-6" [ngClass]="isDarkTheme ? 'text-dark-theme' : 'text-light-theme'">
          <a [href]="'contactInfo.packoHomepageContact' | transloco" target="_blank">{{ 'login.contactUs' | transloco }}</a>
          {{ 'login.moreInfo' | transloco }}
        </span>
      </div>
    </div>
    <app-version data-automation-id="app-version"></app-version>
  </div>
</div>

